import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/lib/settings";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import AIChat from "@/pages/AIChat";
import OrderConfirm from "@/pages/OrderConfirm";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SellerRegister from "@/pages/SellerRegister";
import SalesRegister from "@/pages/SalesRegister";
import Marketplace from "@/pages/Marketplace";
import { FAQ, Terms, Privacy, ReturnPolicy } from "@/pages/Policies";

function App() {
  return (
    <div className="App bg-slate-950 text-slate-100 min-h-screen flex flex-col">
      <SettingsProvider>
        <BrowserRouter>
          <Nav />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/register" element={<Register />} />
              <Route path="/chat" element={<AIChat />} />
              <Route path="/confirm/:orderId" element={<OrderConfirm />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/seller/register" element={<SellerRegister />} />
              <Route path="/sales/register" element={<SalesRegister />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/return" element={<ReturnPolicy />} />
            </Routes>
          </div>
          <Footer />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
